/* eslint-disable react/require-default-props */
import React, { useState } from 'react';
import camelToCapitalize from '@utils/functions/camelToCapitalize';
import { translate } from '@utils/i18n';
import { humanizeInspectableType } from '../../utils/humanizeInspectableType';
import { IssueStatusEnum } from '../../types';
import ManagerNote from './ManagerNote';
import IssueLayout from './IssueLayout';
import MultipleSuggestionsSection from './MultipleSuggestionsSection';
import SingleSuggestionSection from './SingleSuggestionSection';
import getLocalizedQuestionText from '../../utils/getLocalizedQuestionText';
import getCurrentLanguage from '../../utils/getCurrentLanguage';
import './styles.scss';
export default function UlcReferenceClauseCheckCard({ issue, defaultExpanded, onToggle, onUpdateIssue, onUndoAction, readOnly = false }) {
    var _a, _b, _c, _d, _e, _f;
    const userLanguage = getCurrentLanguage();
    const status = issue.status || IssueStatusEnum.Detected;
    const [suggestedClauses, setSuggestedClauses] = useState(((_a = issue.issueData) === null || _a === void 0 ? void 0 : _a.suggestedClauses) || []);
    const hasMultipleSuggestions = suggestedClauses.length > 1;
    // Handler functions for issue actions
    const handleSuggestCorrection = () => {
        onUpdateIssue(issue.id, status, true, undefined, suggestedClauses.filter((clause) => clause.selected).map((clause) => clause.section));
    };
    const handleDismissIssue = () => {
        onUpdateIssue(issue.id, IssueStatusEnum.DismissedByBackOffice, false);
    };
    const handleNoteChange = (note) => {
        onUpdateIssue(issue.id, status, issue.markedForSuggestion, note);
    };
    const handleUpdateSelectedClause = (selectedClause) => {
        setSuggestedClauses(suggestedClauses.map((clause) => {
            if (clause.section === selectedClause) {
                return Object.assign(Object.assign({}, clause), { selected: !clause.selected });
            }
            return clause;
        }));
    };
    return (React.createElement(IssueLayout, { issueType: issue.issueData.violation === 'incorrect_clause' ? 'incorrect_reference_code' : 'blank_reference_code', status: status, defaultExpanded: defaultExpanded, onToggle: onToggle, onSuggestCorrection: handleSuggestCorrection, onDismissIssue: handleDismissIssue, onUndoAction: onUndoAction, readOnly: readOnly, statusChanges: issue.statusChanges, markedForSuggestion: issue.markedForSuggestion },
        React.createElement(React.Fragment, null,
            React.createElement("div", null,
                React.createElement("p", null, issue.issueData.violation === 'incorrect_clause'
                    ? translate('ulc_incorrect_reference_code', { namespace: 'features.iim_review.issue_card' })
                    : translate('ulc_blank_reference_code', { namespace: 'features.iim_review.issue_card' })),
                React.createElement("hr", { className: "section__split" }),
                React.createElement("p", null,
                    React.createElement("b", null,
                        ((_b = issue.question) === null || _b === void 0 ? void 0 : _b.type) && camelToCapitalize(issue.question.type),
                        " /",
                        ' ',
                        humanizeInspectableType((_c = issue.inspectable) === null || _c === void 0 ? void 0 : _c.type)),
                    React.createElement("br", null),
                    React.createElement("span", null, getLocalizedQuestionText(issue.question, userLanguage)),
                    ((_e = (_d = issue.deficiency) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.notes) && (React.createElement(React.Fragment, null,
                        React.createElement("br", null),
                        React.createElement("br", null),
                        React.createElement("b", null, "Notes"),
                        React.createElement("br", null),
                        React.createElement("span", null, issue.deficiency.data.ulcReferenceClause
                            ? `${issue.deficiency.data.ulcReferenceClause} - ${issue.deficiency.data.notes}`
                            : issue.deficiency.data.notes)))),
                React.createElement("hr", { className: "section__split" }),
                hasMultipleSuggestions ? (React.createElement(MultipleSuggestionsSection, { suggestedClauses: suggestedClauses, onUpdateSelectedClause: handleUpdateSelectedClause, 
                    // markedForSuggestion={issue.markedForSuggestion} // TODO: We need to discuss it with the product team
                    markedForSuggestion: true })) : (React.createElement(SingleSuggestionSection, { suggestedClause: suggestedClauses[0] }))),
            issue.markedForSuggestion && (!readOnly || ((_f = issue.managerNote) === null || _f === void 0 ? void 0 : _f.trim())) && (React.createElement(ManagerNote, { note: issue.managerNote || '', onNoteChange: handleNoteChange, disabled: readOnly })))));
}
